import PortalOrderDetailContainer from '@components/containers/b2b/portal/PortalOrderDetail';
import { B2B_NAV_ITEMS } from '@constants/sidebar';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const PortalOrderDetail: FC = () => (
    <VendorLayout navItems={B2B_NAV_ITEMS}>
        <PortalOrderDetailContainer />
    </VendorLayout>
);

export default PortalOrderDetail;
